import { createSelector } from 'reselect';
import Perimeter from '../data/eastEndPerimeter.json';

const getSelectedGravestone = state => state.selectedGravestone;
const getGravestones = state => state.gravestones;
const getBounds = state => state.bounds;
const getZoom = state => state.zoom;

export const getPerimeter = () => Perimeter;

export const getSelectedInfo = createSelector(
  [getSelectedGravestone, getGravestones],
  (selectedGravestone, gravestones) => {
    let gravestone = gravestones.find(g => g.id === selectedGravestone);
    if (gravestone) {
      const { nf: first_name, nm: middle_name, nl: last_name, by: birth_year, bm: birth_month, bd: birth_day, dy: death_year, dm: death_month, dd: death_day, id, n, t } = gravestone;

      const prettyDate = (date) => {
        const months = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        if (date.year === 0) {
          return '';
        }

        if (date.day !== null && date.month !== null && date.year !== null && date.day !== '' && date.month !== '' && date.year !== '') {
          return `${months[date.month]} ${date.day}, ${date.year}`;
        }

        if (date.month !== null && date.year !== null && date.month !== '' && date.year !== '') {
          return `${months[date.month]} ${date.year}`;
        }

        if (date.year !== null && date.year !== '') {
          return date.year;
        }

        return 'unspecified';
      };

      const name = `${first_name} ${(typeof middle_name !== 'undefined') ? middle_name : ''} ${last_name}`;
      const dob = prettyDate({
        year: birth_year,
        month: birth_month,
        day: birth_day,
      });
      const dod = prettyDate({
        year: death_year,
        month: death_month,
        day: death_day,
      });

      return {
        name,
        dob,
        dod,
        id,
        n: (t !== 'Highly Accurate') ? n : false,
      };
    }
    return false;
  }
);

export const getSearchOptions = createSelector(
  [getGravestones],
  (gravestones) => {
    return gravestones
      .filter(g => g.lat && g.id && !g.t.includes('Duplicate'))
      .map((g) => {
        return {
          name: g.searchName,
          id: g.id,
        };
      })
      .sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        } else if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
  }
);

export const getGravestonesParsed = createSelector(
  [getGravestones, getSelectedGravestone, getZoom],
  (gravestones, selectedGravestone, zoom) => {
    return gravestones
      .filter(g => g.lat && g.id)
      .map((g) => {
        const { dy: death_year, id, t } = g;
        let radius = 1 - (1 - 0.05) * ((zoom - 15) / (26 - 15));
        //let radius = 0.3;


        let fill = (t === 'Highly Accurate') ? '#8D5649' : '#D8241F';
        if (t === 'Highly Accurate') {
          if (death_year < 2002 && death_year >= 1980) {
            fill = '#1b9e77';
          } else if (death_year < 1980 && death_year >= 1970) {
            fill = '#d95f02';
          } else if (death_year < 1970 && death_year >= 1960) {
            fill = '#7570b3';
          } else if (death_year < 1960 && death_year >= 1950) {
            fill = '#e7298a';
          } else if (death_year < 1950 && death_year >= 1940) {
            fill = '#66a61e';
          } else if (death_year < 1940 && death_year >= 1920) {
            fill = '#e6ab02';
          } else if (death_year && death_year < 1920) {
            fill = '#666666';
          }
        }

        let fillOpacity = 0.75;
        let opacity = 1;
        let weight = 0.5;
        if (selectedGravestone && id !== selectedGravestone) {
          fillOpacity = 0.2;
          opacity = 0.2;

        }
        if (selectedGravestone && id === selectedGravestone) {
          fillOpacity = 0.9;
          weight = 1.5;
        }


        return {
          center: [g.lat, g.lng],
          radius,
          opacity,
          weight,
          fill,
          fillOpacity,
          id: g.id,
          key: `gravetone-${g.id}${(g.t === 'Duplicate') ? '-duplicate' : ''}`,
        };
      });
  }
);

export const showInset = createSelector(
  [getBounds],
  (bounds) => {
    // do a rough calculation to figure out how much of the visible bounds overlaps the rough perimeter of East End
    const lngMin = -77.39003419876099;
    const lngMax = -77.38542884588242;
    const latMin = 37.535295961999424;
    const latMax = 37.53819278876113;
    const eeArea = (lngMax - lngMin) * (latMax - latMin);
    let { n, s, e, w } = _getNSWE(bounds);

    w = (w > lngMin) ? w : lngMin;
    e = (e < lngMax) ? e : lngMax;
    n = (n < latMax) ? n : latMax;
    s = (s > latMin) ? s : latMin;

    const overlapArea = (n - s) * (e - w);
    return overlapArea / eeArea <= 0.7;
  }
);

function _getNSWE(bounds) {
  return {
    n: Math.max(bounds[0][0], bounds[1][0]),
    s: Math.min(bounds[0][0], bounds[1][0]),
    e: Math.max(bounds[0][1], bounds[1][1]),
    w: Math.min(bounds[0][1], bounds[1][1]),
  };
}



// WEBPACK FOOTER //
// ./src/store/selectors.js